import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { DSHeader } from '@elliemae/ds-header';
import DSTruncatedTooltipText, { TooltipTextProvider } from '@elliemae/ds-truncated-tooltip-text';
import { CardContainer, LeftSection, LeftAddon, MainSection, Description, RightAddonSection, RightAddon, Separator } from './components.js';
import 'styled-components';
import '@elliemae/ds-grid';

var getCol = function getCol(rightAddon) {
  if (!rightAddon) return [1];
  return [1, 'auto'];
};

var CustomCard = function CustomCard(_ref) {
  var title = _ref.title,
      description = _ref.description,
      leftAddon = _ref.leftAddon,
      rightAddon = _ref.rightAddon,
      _ref$hasBorder = _ref.hasBorder,
      hasBorder = _ref$hasBorder === void 0 ? false : _ref$hasBorder;
  return /*#__PURE__*/React.createElement(TooltipTextProvider, null, /*#__PURE__*/React.createElement(CardContainer, {
    hasBorder: hasBorder,
    cols: getCol(rightAddon),
    "data-testid": "em-ds-card"
  }, /*#__PURE__*/React.createElement(LeftSection, null, leftAddon && /*#__PURE__*/React.createElement(LeftAddon, null, leftAddon), /*#__PURE__*/React.createElement(MainSection, {
    style: {
      maxWidth: leftAddon ? 'calc(100% - 40px)' : '100%'
    }
  }, /*#__PURE__*/React.createElement(DSHeader, {
    fontSize: "16px",
    "data-testid": "em-ds-card-header",
    fontWeight: "regular",
    color: "neutral.800",
    text: /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
      value: title
    })
  }), description && /*#__PURE__*/React.createElement(Description, null, /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    value: description
  })))), rightAddon && /*#__PURE__*/React.createElement(RightAddonSection, null, rightAddon[0] && /*#__PURE__*/React.createElement(RightAddon, null, rightAddon[0]), rightAddon[1] && /*#__PURE__*/React.createElement(React.Fragment, null, rightAddon.length > 1 && /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(RightAddon, null, rightAddon[1])))));
};

var cardProps = {
  /**
   * Title of the card. requiered
   */
  title: PropTypes.string.isRequired.description('Title of the card. requiered'),

  /**
   * Description of the card. not requiered
   */
  description: PropTypes.string.description('Description of the card. not requiered'),

  /**
   * Left Addon
   */
  leftAddon: PropTypes.element.description('Left Addon'),

  /**
   * Right addon array, max elements: 2
   */
  rightAddon: PropTypes.array.description('Right addon array, max elements: 2'),

  /**
   * Wheter if the card has border or not
   */
  hasBorder: PropTypes.bool.description('Wheter if the card has border or not')
};
CustomCard.propTypes = cardProps;
var DSCardCustomWithSchema = describe(CustomCard);
DSCardCustomWithSchema.propTypes = cardProps;

export default CustomCard;
export { CustomCard, DSCardCustomWithSchema };
//# sourceMappingURL=Card.js.map
